import { toPascalCase } from '@cli-utils/text.js'

export function replaceIdentifierExact(text: string, before: string, after: string): string {
  const beforePascal = toPascalCase(before)
  const afterPascal = toPascalCase(after)
  const variants = new Map<string, string>([
    [before, after],
    [`${before}Html`, `${after}Html`],
    [`${before}Field`, `${after}Field`],
    [`${before}FieldArray`, `${after}FieldArray`],
    [`${before}Open`, `${after}Open`],
    [`${before}Expanded`, `${after}Expanded`],
    [`${before}From`, `${after}From`],
    [`${before}To`, `${after}To`],
    [`${before}Media`, `${after}Media`],
    [`${before}MediaIds`, `${after}MediaIds`],
    [beforePascal, afterPascal],
    [`${beforePascal}Field`, `${afterPascal}Field`],
    [`${beforePascal}Column`, `${afterPascal}Column`],
    [`${beforePascal}Props`, `${afterPascal}Props`],
    [`set${beforePascal}Open`, `set${afterPascal}Open`],
    [`set${beforePascal}Expanded`, `set${afterPascal}Expanded`]
  ])

  return variants.get(text) ?? text
}
